import React, { useEffect, lazy } from "react"
import {Navigate, Routes, Route } from "react-router-dom"
import HomeLayout from "./components/HomeLayout"
import PopupLayout from "./components/PopupLayout"
import Layout from "./components/Layout"
import ReactGA from 'react-ga';
import Home from "./views/Home";
import Article from "./views/Article";
import FoodType from "./views/FoodType";
import LannaFood from "./views/LannaFood";
import LannaFoodPic from "./views/LannaFoodPic";
import LannaFoodMethod from "./views/LannaFoodMethod";
import LannaFoodClip from "./views/LannaFoodClip";
import Ingredient from "./views/Ingredient";
import Expert from "./views/Expert";
import Search from "./views/Search";
const TRACKING_ID = "G-RB0QHFC6LF"; // OUR_TRACKING_ID

ReactGA.initialize(TRACKING_ID);

function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <Routes>
        <Route path="/" element={<HomeLayout />} >
            <Route path="*" element={<Home />} />
            <Route path="/" element={<Home />} />
        </Route>
        <Route element={<PopupLayout />} >
            <Route path="/lannafood-pic/:foodId" element={<LannaFoodPic />} />
            <Route path="/lannafood-method/:foodId" element={<LannaFoodMethod />} />
            <Route path="/lannafood-clip/:foodId" element={<LannaFoodClip />} />
        </Route>
        <Route element={<Layout />} >
            <Route path="/food-type" element={<FoodType />} />
            <Route path="/food-type/:itemId" element={<FoodType />} />
            <Route path="/lannafood/:foodId" element={<LannaFood />} />
            <Route path="/activities" element={<Article articleType={"2"} />} />
            <Route path="/article/:articleId" element={<Article />} />
            <Route path="/search/:searchtype" element={<Search />} />
            <Route path="/ingredient" element={<Ingredient />} />
            <Route path="/ingredient/:ingredientId" element={<Ingredient />} />
            <Route path="/expert" element={<Expert />} />
            <Route path="/expert/:expertId" element={<Expert />} />
            {/* <Route path='/about' element={<Navigate to='/article/1' />} /> */}
        </Route>
        {/* <Route path="/welcome" element={<AccessRegis />} />
        <Route path="/callback" element={<AccessRegisCallback />} /> */}
    </Routes>
  );
}

export default App;
